const faqs = [
  {
    q: '今日看料的内容来源是什么？',
    a: '我们的内容来自专业编辑团队的每日精选和用户投稿，所有内容均经过人工审核，确保真实性和可读性。',
  },
  {
    q: '如何下载今日看料App？',
    a: '您可以在页面中的"移动端下载"区域找到下载入口，支持iOS和Android双平台，或直接在应用商店搜索"今日看料"下载。',
  },
  {
    q: '网站打不开了怎么办？',
    a: '我们会定期更新官网访问地址，请关注我们的官方社交媒体账号获取最新入口信息，或使用App访问更加稳定可靠。',
  },
  {
    q: '如何向平台投稿或爆料？',
    a: '欢迎通过"联系我们"区域的联系方式进行投稿，我们会对有价值的内容给予相应奖励，期待您的独家猛料。',
  },
  {
    q: '平台内容更新频率如何？',
    a: '我们实行7×24小时不间断更新机制，每天更新超过200条精选内容，确保用户随时都能看到最新资讯。',
  },
  {
    q: '今日看料收费吗？',
    a: '平台所有内容均为免费浏览，App下载也完全免费。我们通过广告收入维持运营，不会向用户收取任何费用。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          常见问答
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          你想知道的都在这里
        </p>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200/60 transition-colors duration-200"
            >
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 flex items-start gap-2">
                <span className="text-primary-500 shrink-0 mt-0.5">
                  <i className="ri-question-line text-base"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-6">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}